<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title"><a id="page_5">Contents</a></p><a id="page_5">
</a><p class="tocfm"><a id="page_5"></a><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></p>
<p class="tocfm1"><a href="#/xhtml/06_Introduction">Introduction</a></p>
<p class="tocfm2"><a href="#/xhtml/07_The_Home_Front">The Home Front</a></p>
<p class="toc1"><span href="#/xhtml/08_Section01" title="Link target outside of Sample"><i>Section 1    The pre-war world</i></span></p>
<p class="toc1"><span href="#/xhtml/09_Section02" title="Link target outside of Sample"><i>Section 2    Mobilisation, recruiting and departure</i></span></p>
<p class="toc1"><span href="#/xhtml/10_Section03" title="Link target outside of Sample"><i>Section 3    Getting ready for war</i></span></p>
<p class="toc1"><span href="#/xhtml/11_Section04" title="Link target outside of Sample"><i>Section 4    Wartime life</i></span></p>
<p class="toc1"><span href="#/xhtml/12_Section05" title="Link target outside of Sample"><i>Section 5    Propaganda</i></span></p>
<p class="toc1"><span href="#/xhtml/13_Section06" title="Link target outside of Sample"><i>Section 6    Casualties</i></span></p>
<p class="toc1"><span href="#/xhtml/14_Section07" title="Link target outside of Sample"><i>Section 7    Personalities</i></span></p>
<p class="toc1"><span href="#/xhtml/15_Section08" title="Link target outside of Sample"><i>Section 8    Refugees</i></span></p>
<p class="toc1"><span href="#/xhtml/16_Section09" title="Link target outside of Sample"><i>Section 9    News</i></span></p>
<p class="toc1a"><span href="#/xhtml/17_Section10" title="Link target outside of Sample"><i>Section 10  Raids and occupation</i></span></p>
<p class="toc1a"><span href="#/xhtml/18_Section11" title="Link target outside of Sample"><i>Section 11  Joining in</i></span></p>
<p class="toc1a"><span href="#/xhtml/19_Section12" title="Link target outside of Sample"><i>Section 12  Christmas</i></span></p>
<p class="tocbm"><span href="#/xhtml/20_Chronology" title="Link target outside of Sample">Day by day chronology</span></p>
<p class="tocbm"><span href="#/xhtml/21_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?41e83da6